import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { VillaHostSignupButton } from "../VillaHostSignupButton";
export const VillaHostStickyCTA = () => {
  const $ = _c(9);
  const reference = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        if (!reference.current) {
          return;
        }
        const {
          top
        } = reference.current.getBoundingClientRect();
        setIsSticky(top < 0);
      };
      window.addEventListener("scroll", handleScroll);
      handleScroll();
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div ref={reference} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `${isSticky ? "border-t-outline-thin fixed inset-x-0 bottom-0 z-50 h-[68px] rounded-t-lg border-t bg-white px-4 py-[14px] shadow-[0px_2px_4px_-1px_#00000033,0px_4px_5px_0px_#00000024,0px_1px_10px_0px_#0000001F]" : "relative w-full"}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VillaHostSignupButton className="w-full" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <div className={t3}>{" "}{t4}</div>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-on-surface-high-emphasis text-xs">دیده شوید، رزرو بگیرید، درآمد کسب کنید</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <>{t2}<div className="pb-9"><div className="flex w-full flex-col gap-2">{t5}{t6}</div></div></>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};